import { useRouter } from "next/router";
import { getResolvedDomain } from "utils/site";

export function useCanonicalUrl() {
  const { defaultLocale, locale, asPath } = useRouter();

  // asPath carries the query string and hash after client-side hydration
  // (?utm_source=... etc) — the canonical must stay the bare path.
  const path = asPath.split(/[?#]/)[0];

  // A secondary locale's tree root is served at /<locale>, with no trailing
  // slash. Composing it from a root path of "/" would otherwise canonicalise
  // to /<locale>/, which redirects straight back to the page declaring it.
  const localizedPath =
    defaultLocale !== locale ? `${locale}${path}`.replace(/\/$/, "") : path;

  return new URL(localizedPath, `https://${getResolvedDomain()}`).toString();
}
